import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import SentEmailsPaginatedGql from '@/extensions/newsletter/store/graphql/queries/SentEmailsPaginated.gql';
import SentEmailGql from '@/extensions/newsletter/store/graphql/queries/SentEmail.gql';
import NewsletterUrlClicksGql from '@/extensions/newsletter/store/graphql/queries/NewsletterUrlClicks.gql';
import NewsletterUrlClickersGql from '@/extensions/newsletter/store/graphql/queries/NewsletterUrlClickers.gql';
import NewsletterStatisticsTimelineGql from '@/extensions/newsletter/store/graphql/queries/NewsletterStatisticsTimeline.gql';

export default {
    fetchPaginated: (newsletterId, data) =>
        new Promise((resolve, reject) => {
            let filters = [];
            _.each(data.filters, entry => filters.push(entry));

            apolloClient
                .query({
                    query: SentEmailsPaginatedGql,
                    variables: {
                        newsletter_id: parseInt(newsletterId),
                        currentPage: _.get(data, 'pageInfo.currentPage', 1),
                        perPage: _.get(data, 'pageInfo.perPage', 25),
                        order: _.get(data, 'variables.order', 'created_at'),
                        direction: _.get(data, 'variables.direction', 'desc'),
                        filters
                    },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_NWSLTR_SentEmailsPaginated))
                .catch(err => reject(err));
        }),

    fetchSingle: id =>
        new Promise((resolve, reject) => {
            if (id === undefined) throw new Error('required argument is missing');

            apolloClient
                .query({
                    query: SentEmailGql,
                    variables: { id: parseInt(id) },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_NWSLTR_SentEmail))
                .catch(err => reject(err));
        }),

    fetchUrlClicks: newsletterId =>
        new Promise((resolve, reject) => {
            if (newsletterId === undefined) throw new Error('required argument is missing');

            apolloClient
                .query({
                    query: NewsletterUrlClicksGql,
                    variables: { newsletter_id: parseInt(newsletterId) },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_NWSLTR_NewsletterUrlClicks))
                .catch(err => reject(err));
        }),

    fetchUrlClickers: (newsletterId, url, currentPage, perPage) =>
        new Promise((resolve, reject) => {
            if (newsletterId === undefined || url === undefined) {
                throw new Error('required argument is missing');
            }

            apolloClient
                .query({
                    query: NewsletterUrlClickersGql,
                    variables: {
                        newsletter_id: parseInt(newsletterId),
                        url: url,
                        currentPage: currentPage || 1,
                        perPage: perPage || 25
                    },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_NWSLTR_NewsletterUrlClickers))
                .catch(err => reject(err));
        }),

    fetchStatisticsTimeline: (newsletterId, granularity, start, end, maxTimespan) =>
        new Promise((resolve, reject) => {
            if (newsletterId === undefined) throw new Error('required argument is missing');

            const variables = {
                newsletter_id: parseInt(newsletterId),
                granularity: granularity || null
            };

            if (start !== undefined && start !== null) {
                variables.start = start;
            }
            if (end !== undefined && end !== null) {
                variables.end = end;
            }
            if (maxTimespan !== undefined && maxTimespan !== null) {
                variables.maxTimespan = maxTimespan;
            }

            apolloClient
                .query({
                    query: NewsletterStatisticsTimelineGql,
                    variables,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.EX_NWSLTR_NewsletterStatisticsTimeline))
                .catch(err => reject(err));
        })
};
